// app/components/OperationModels.tsx
"use client";

import * as React from "react";
import {
    Box,
    Card,
    CardContent,
    Container,
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Stack,
    Tab,
    Tabs,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Paper,
    Button,
    Chip,
} from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import CostBreakdownTable from "./CostBreakdownTable";
import InvestorOwnedInfoCard from "./InvestorOwnedInfoCard";
import Heading from "../heading";
import CtaButton from "../buttonWithArrow";
import Image from "next/image";

export default function OperationModels({ data, onClick }) {
    const { title, subtitle, tabData, bottomHeader, bottomSubHeader, button, bottomData } = data;
    const [tab, setTab] =
        React.useState(null);

    React.useEffect(() => {
        if (tabData && tabData?.length > 0) {
            setTab(tabData[0])
        }
    }, [tabData])

    return (
        <Box sx={{ py: { xs: 4, md: 4 }, bgcolor: "#f7f9fc" }}>
            <Container maxWidth="md">
                <Stack spacing={3} alignItems="center" textAlign="center">
                    {/* Header */}
                    <Heading title={title} subtitle={subtitle} />


                </Stack>

                {/* Tabs */}
                <Stack
                    direction="row"
                    spacing={1.5}
                    justifyContent="center"
                    sx={{ mt: { xs: 4, md: 8 } }}
                >
                    {
                        tabData?.map((t, index) => (
                            <Chip
                                key={index}
                                clickable
                                color={tab?.value === t?.value ? "primary" : undefined}
                                onClick={() => setTab(t)}
                                label={t?.label}
                                sx={pillSx(tab?.value === t?.value)}
                            />
                        ))
                    }
                </Stack>

                {tab && (
                    <Box sx={{ my: 4, position: "relative" }}>
                        <InvestorOwnedInfoCard surfaceColor="#f7f9fc" data={tab?.listData} />

                        {/* Arrow at bottom-right of the card */}
                        <Box
                            aria-hidden
                            sx={{
                                position: "absolute",
                                bottom: { xs: -10, sm: -12, md: -62 }, // negative -> slightly outside the card
                                right: { xs: 12, sm: 16, md: -15 },     // align with card padding
                                pointerEvents: "none",
                                zIndex: 3,
                            }}
                        >
                            {/* Inner box must be relative for <Image fill /> */}
                            <Box
                                sx={{
                                    position: "relative",
                                    width: { xs: 64, sm: 84, md: 100 },
                                    height: { xs: 64, sm: 84, md: 100 },
                                }}
                            >
                                <Image
                                    src="/img/investments/Arrow.svg"
                                    alt="arrow"
                                    fill
                                    style={{ objectFit: "contain" }}
                                    priority
                                />
                            </Box>
                        </Box>
                    </Box>
                )}


                {
                    tab &&
                    <Box>
                        <CostBreakdownTable data={tab?.tableData} footerData={tab?.tableFooter} surfaceColor="#f7f9fc" />
                    </Box>
                }


            </Container>

            {/* CTA */}
            {
                button &&
                <Stack alignItems="center" sx={{ mt: { xs: 2, md: 4 } }}>
                    <CtaButton label={button?.text} onClick={() => onClick()} />
                    {/* <CtaButton cta={{ label: button?.text, href: button?.link }} /> */}
                </Stack>
            }


        </Box>
    );
}

/* --------- Helpers --------- */
const pillSx = (active) => ({
    flexShrink: 0,
    fontWeight: 700,
    borderRadius: "999px",
    px: { xs: 1.5, md: 2.5 },
    py: { xs: 1, md: 3 },
    fontSize: { xs: 14, md: 16 },
    background: active
        ? "linear-gradient(180deg, #75c4c5 0%, #0d8196 100%)"
        : "#fff",
    color: active ? "#fff" : "#000",
    "&:hover": {
        background: active
            ? "linear-gradient(180deg, #4bb6b4 0%, #249f9c 100%)"
            : "#f7f9f9",
    },
    "& .MuiChip-label": { px: 0, fontWeight: 700 },
});